export default "__VITE_ASSET__jsrFzDIz__"